
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[domain]/search",
      function () {
        return require("private-next-pages/[domain]/search/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[domain]/search"])
      });
    }
  